import 'css-chunk:src/feature/check-item-detail/CheckItemDetailButton.module.scss';export default {
  "root": "CheckItemDetailButton_root",
  "pulse": "CheckItemDetailButton_pulse",
  "name": "CheckItemDetailButton_name"
};